import { createContext, useContext } from 'react'
import { Optional } from '@/types/optional'
import { KolSchemaModel } from '@/types/schema/kol-schema'

type KolInfoContextProps = Optional<{
  info?: KolSchemaModel
  infoForOpenGraph?: KolSchemaModel
}>

const KolInfoContext = createContext<KolInfoContextProps>(undefined)

const useKolInfoContext = (): KolInfoContextProps => useContext(KolInfoContext)

/**
 * 預期只會放 server side 傳過來的 KolInfo，
 * 當外層有此 Provider 且有提供值時，useKolInfo 將不會再另外打 API。
 */
export const KolInfoProvider = KolInfoContext.Provider

export default useKolInfoContext
